var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"loading-wrap"},[_c('div',{staticClass:"loading-box"},[_c('img',{attrs:{"src":require("@/assets/images/loading-bars.svg")}}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.content))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }